$(document).ready(function () {
  function convertToPersianNumbers(str) {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    return str.replace(/\d/g, function (match) {
      return persianNumbers[match];
    });
  }

  function traverseAndConvert(node) {
    if (node.nodeType === 3) {
      // Node.TEXT_NODE
      node.nodeValue = convertToPersianNumbers(node.nodeValue);
    } else if (node.nodeType === 1) {
      // Node.ELEMENT_NODE
      const $node = $(node);
      if (!$node.hasClass("no-convert")) {
        $node.contents().each(function () {
          traverseAndConvert(this);
        });
      }
    }
  }

  traverseAndConvert(document.body);
});
